/** Отображаемое имя провайдера. Вынесено из компонента: его импортирует и профиль. */

import type { OAuthProvider } from '@/api/oauth'
import { strings } from '@/lib/strings'

export function providerName(provider: OAuthProvider): string {
  return strings.auth.providerNames[provider]
}
